if (!customElements.get('sf-original-gallery')) {
  customElements.define('sf-original-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.galleryReady) return;
      this.galleryReady = true;
      const photos = [...this.querySelectorAll('[data-photo-index]')];
      const dialog = this.querySelector('dialog');
      const image = this.querySelector('[data-photo-viewer]');
      const position = this.querySelector('[data-photo-position]');
      const close = this.querySelector('[data-photo-close]');
      const previous = this.querySelector('[data-photo-previous]');
      const next = this.querySelector('[data-photo-next]');
      let current = 0;
      let returnFocus;
      const show = (index) => {
        current = (index + photos.length) % photos.length;
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src = photos[current].dataset.fullSrc;
        image.alt = photos[current].dataset.photoAlt;
        position.textContent = `${current + 1} / ${photos.length}`;
        previous.disabled = next.disabled = photos.length < 2;
      };
      photos.forEach((button, index) => {
        button.addEventListener('click', () => {
          returnFocus = button;
          show(index);
          dialog.showModal();
          close.focus();
        });
        button.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          photos[(index + (event.key === 'ArrowRight' ? 1 : -1) + photos.length) % photos.length].focus();
        });
      });
      previous.addEventListener('click', () => show(current - 1));
      next.addEventListener('click', () => show(current + 1));
      close.addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => returnFocus?.focus({ preventScroll: true }));
      dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
      dialog.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          show(current + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
    }
  });
}

